import { isNotProductionMode } from '@dxb-web-ui-framework/common/domain/Environment/EnvironmentService';
import brandLogo from '../assets/logo.png';
import ecommbxDesktopBrandLogo from '../assets/ecommbxDesktopBrandLogo.svg';
import ecommbxMobileBrandLogo from '../assets/ecommbxMobileBrandLogo.svg';
import { SpiltScreenTypes } from '../../../packages/content-composer/src/components/Layouts/types';

const baseUrl = isNotProductionMode() ? '/ecommbx/public-web' : '/';

const brandedAppConfig = {
  baseName: baseUrl,
  featureFlags: {
    activationFlowEnabled: false,
  },
  layout: {
    logo: brandLogo,
    logoAlt: 'ecommbx-logo',
  },
  landingPage: {
    title: 'brandedAppConfig.landingPage.Title',
    layout: {
      type: 'SplitScreenLayout',
      moto: 'brandedAppConfig.landingPage.Moto',
      desktopBrandLogo: ecommbxDesktopBrandLogo,
      mobileBrandLogo: ecommbxMobileBrandLogo,
      logoAlt: 'brandedAppConfig.EcommbxLogo.LogoAlt',
      dataTestId: 'ecommbx-landing-page',
      leftContainerType: SpiltScreenTypes.PUBLIC_APP,
      shouldRemovePadding: true,
    },
  },
  //TODO: for onboardingPage and supportPage see designs when are ready to be worked to see if the pageTitle will be handled
  // SplitScreenLayout does not uses the pageTitle yet.
  onboardingPage: {
    title: 'brandedAppConfig.onboardingPage.Title',
    layout: {
      type: 'SplitScreenLayout',
      moto: 'brandedAppConfig.onboardingPage.Moto',
      desktopBrandLogo: ecommbxDesktopBrandLogo,
      mobileBrandLogo: ecommbxMobileBrandLogo,
      logoAlt: 'brandedAppConfig.EcommbxLogo.LogoAlt',
      dataTestId: 'ecommbx-onboarding-page',
      leftContainerType: SpiltScreenTypes.PUBLIC_APP,
    },
  },
  supportPage: {
    title: 'brandedAppConfig.supportPage.Title',
    layout: {
      type: 'SplitScreenLayout',
      pageTitle: 'brandedAppConfig.supportPage.PageTitle',
      moto: 'brandedAppConfig.supportPage.Moto',
      desktopBrandLogo: ecommbxDesktopBrandLogo,
      mobileBrandLogo: ecommbxMobileBrandLogo,
      logoAlt: 'brandedAppConfig.EcommbxLogo.LogoAlt',
      dataTestId: 'ecommbx-support-page',
      leftContainerType: SpiltScreenTypes.PUBLIC_APP,
    },
  },
  securityTipsPage: {
    title: 'brandedAppConfig.securityTipsPage.Title',
    layout: {
      type: 'SplitScreenLayout',
      pageTitle: 'brandedAppConfig.securityTipsPage.PageTitle',
      moto: 'brandedAppConfig.securityTipsPage.Moto',
      desktopBrandLogo: ecommbxDesktopBrandLogo,
      mobileBrandLogo: ecommbxMobileBrandLogo,
      logoAlt: 'brandedAppConfig.EcommbxLogo.LogoAlt',
      dataTestId: 'ecommbx-security-tips-page',
      leftContainerType: SpiltScreenTypes.PUBLIC_APP,
    },
  },
  emailVerificationPage: {
    title: 'brandedAppConfig.emailVerificationPage.Title',
    layout: {
      type: 'SplitScreenLayout',
      backButton: false,
      desktopBrandLogo: ecommbxDesktopBrandLogo,
      mobileBrandLogo: ecommbxMobileBrandLogo,
      logoAlt: 'brandedAppConfig.EcommbxLogo.LogoAlt',
      dataTestId: 'ecommbx-email-verification-page',
      leftContainerType: SpiltScreenTypes.PUBLIC_APP,
    },
  },
  errorPage: {
    title: 'brandedAppConfig.securityTipsPage.Title',
    layout: {
      type: 'Generic',
      backButton: false,
      dataTestId: 'error-page',
    },
  },
  successPage: {
    title: 'brandedAppConfig.securityTipsPage.Title',
    layout: {
      type: 'Generic',
      backButton: false,
      dataTestId: 'success-page',
    },
  },
};

export { brandedAppConfig };
